// extracted by mini-css-extract-plugin
export default {"oddRow":"TabBaechaUpdateHistory_oddRow__Eh3G+"};